<style lang="scss" scoped>
// .equ {
//   position: absolute;
//   width: 415px;
//   height: 201px;
//   right: 1px;
//   top: 0px;
//   background-image: url("../../../../../assets/pagesImg/equ-transfrom.png");
// }

.equ{
  width: 415px;
  height: 200px;
  cursor: pointer;
  .battery{
    margin-top: 20px;
    padding: 0 20px;
    display: flex;
    justify-content: space-evenly;
    text-align: center;
    .num{
      height: 92px;
      font-size: 18px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      p:nth-child(2){
        font-family: 'dina';
        font-size: 48px;
      }
      .zc{
        color:rgba(45, 130, 255, 1);
      }
      .gz{
        color:#F1802F;
      }
    }
  }
}
</style>

<template>
  <div class="equ" @click="to('/eletransfrom')">
      <custom-plane title="变配电系统"
      :iconImg="require('@/assets/compImg/EquipmentIcon/battery.png')">
      <div class="battery">
        <div class="num">
          <p>正常数量</p>
          <p class="zc">{{number1}}</p>
        </div>
        <div class="num">
          <p>待机数量</p>
          <p>{{number2}}</p>
        </div>
        <div class="num">
          <p>故障数量</p>
          <p class="gz">{{number3}}</p>
        </div>
      </div>
    </custom-plane>
  </div> 
</template>

<script>
export default {
  props:{
    number1:Number,
    number2:Number,
    number3:Number,
  },
  methods:{
    to(path){
      this.$router.push({path})
    }
  }
}
</script>
